import { data } from '../../svg/Unarchive/data';
import { makeIcon } from '../makeIcon';

export const Unarchive = makeIcon(data, 'unarchive', 'Unarchive');

export default Unarchive;
